export default __webpack_public_path__ + "static/media/login_bg.9714e1c1.jpg";